import { baseRoutes, notFoundRoute, beforeRouteLeaveMixin } from '@/router'
// Layout 组件是项目中的主页面，切换路由时，仅切换Layout中的组件
import Layout from '@/layout'
import empty from '@/layout/empty'

function getAsyncRoutes(routes = []) {
  const res = []
  // 定义路由中需要的自定名
  const keys = [
    'path',
    'name',
    'children',
    'redirect',
    'meta',
    'hidden',
    'button'
  ]
  // 遍历路由数组去重组可用的路由
  routes.forEach((item) => {
    const newItem = {}
    if (item.component) {
      // 判断 item.component 是否等于 'Layout',若是则直接替换成引入的 Layout 组件
      if (item.component === 'Layout') {
        newItem.component = Layout
      } else if (item.component === 'empty') {
        newItem.component = empty
      } else {
        // newItem.component = () => import(`../../views/${item.component}.vue`)
        // newItem.component = () =>
        newItem.component = (resolve) =>
          require([`@/views/${item.component}`], (...arg) => {
            const comp = arg[0]?.default
            comp.name = item.name
            comp.mixins = Array.isArray(comp.mixins)
              ? comp.mixins.concat(beforeRouteLeaveMixin)
              : [beforeRouteLeaveMixin]
            return resolve(...arg)
          })
        // 此处用reqiure比较好，import引入变量会有各种莫名的错误
        // newItem.component = () => import(`@/views/${item.component}`)
      }
    }

    if (item.meta && typeof item.meta === 'string') {
      item.meta = JSON.parse(item.meta)
      // 业务线数据保存
      if (item.moduleCode) {
        item.meta.moduleCode = item.moduleCode
      }
    }

    for (const key in item) {
      if (keys.includes(key)) {
        newItem[key] = item[key] ? item[key] : undefined
      }
    }

    /** button 配置列表注入meta中 */
    newItem.meta.buttons = newItem.button

    // 若遍历的当前路由存在子路由，需要对子路由进行递归遍历
    if (newItem.children && newItem.children.length) {
      // eslint-disable-next-line no-unused-vars
      newItem.children = getAsyncRoutes(item.children)
    }
    // 对于iframe页面路由处理
    if (newItem.meta.pageId) {
      newItem.meta.component = newItem.component
    }
    res.push(newItem)
  })
  // 返回处理好且可用的路由数组
  return res
}

function filterRoutes(routes) {
  return (routes || []).filter((_) => !_.hidden && _.state == 1)
}

function mapKeyRoute(routes = []) {
  const routesMap = {}
  const P_ROUTES = filterRoutes(routes)
  for (let i = 0; i < P_ROUTES.length; i++) {
    const C_ROUTES = filterRoutes(P_ROUTES[i].children || [])
    for (let j = 0; j < C_ROUTES.length; j++) {
      routesMap[i + '-' + j] = P_ROUTES[i].path + '/' + C_ROUTES[j].path
    }
  }
  // console.log(' init routesMap :', routesMap)
  return routesMap
}

function mapPathTitle(routes = []) {
  const pathMap = {}
  const P_ROUTES = filterRoutes(routes)
  for (let i = 0; i < P_ROUTES.length; i++) {
    const C_ROUTES = filterRoutes(P_ROUTES[i].children || [])
    for (let j = 0; j < C_ROUTES.length; j++) {
      pathMap[P_ROUTES[i].path + '/' + C_ROUTES[j].path] = [
        P_ROUTES[i].meta.title,
        C_ROUTES[j].meta.title
      ]
    }
  }
  // console.log(' init pathMap : ', pathMap)
  return pathMap
}

function mapTitlePath(routes = []) {
  const titleMap = {}
  const P_ROUTES = routes
  // console.log('P_ROUTES ', P_ROUTES)
  for (let i = 0; i < P_ROUTES.length; i++) {
    const C_ROUTES = P_ROUTES[i].children || []
    titleMap[P_ROUTES[i].meta.title] = P_ROUTES[i].path + '/' + C_ROUTES[0].path
    for (let j = 0; j < C_ROUTES.length; j++) {
      titleMap[C_ROUTES[j].meta.title] =
        P_ROUTES[i].path + '/' + C_ROUTES[j].path
    }
  }
  // console.log(' init mapTitlePath : ', titleMap)
  return titleMap
}

function pathCache(routes = []) {
  const pathMap = []
  const P_ROUTES = filterRoutes(routes)
  for (let i = 0; i < P_ROUTES.length; i++) {
    const C_ROUTES = filterRoutes(P_ROUTES[i].children || [])
    for (let j = 0; j < C_ROUTES.length; j++) {
      if (!C_ROUTES[j].meta.noCache) {
        pathMap.push(C_ROUTES[j].name)
      }
    }
  }
  // console.log(' init pathCache : ', pathMap)
  return pathMap
}

function mapPathIndex(routesMap = []) {
  const indexMap = {}
  Object.entries(routesMap).forEach((item) => {
    const [key, value] = item
    indexMap[value] = key
  })
  // console.log(' init indexMap : ', indexMap)
  return indexMap
}

const state = {
  permissionRoutes: [],
  routes: [],
  addRoutes: [],
  sidebarObj: {},
  routesMap: {},
  pathIndex: {},
  pathTitle: {},
  titlePath: {},
  pathCacheList: [],
  permissionCodes: []
}

const mutations = {
  SET_PERMISSION_ROUTES: (state, routes) => {
    state.permissionRoutes = routes
    // console.log(' routes ', routes)
    state.routesMap = mapKeyRoute(routes)
    state.pathIndex = mapPathIndex(state.routesMap)
    state.pathTitle = mapPathTitle(routes)
    state.pathCacheList = pathCache(routes)
  },
  SET_TITLE_PATH: (state, routes) => {
    state.titlePath = mapTitlePath(routes)
  },
  SET_PERMISSION_CODES: (state, codes) => {
    state.permissionCodes = codes
  },
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = baseRoutes.concat(routes)
  },
  SET_SIDEBAR: (state, payload) => {
    state.sidebarObj = { ...payload }
  },
  SET_PATH_TITLE: (state, payload) => {
    state.pathTitle = { ...state.pathTitle, ...payload }
  }
}

const actions = {
  async generateRoutes({ commit }, accessPath) {
    const accessedRoutes = getAsyncRoutes(accessPath?.children)

    accessedRoutes.push(notFoundRoute)

    commit('SET_ROUTES', [...accessedRoutes])
    return Promise.resolve(accessedRoutes)
  },
  setSidebar({ commit }, data) {
    commit('SET_SIDEBAR', data)
  },
  setPermissionRoutes({ commit }, data) {
    commit('SET_PERMISSION_ROUTES', data)
  },
  setTitlePath({ commit }, data) {
    commit('SET_TITLE_PATH', data)
  },
  setPermissionCodes({ commit }, data) {
    commit('SET_PERMISSION_CODES', data)
  },
  setPathTitle({ commit }, data) {
    commit('SET_PATH_TITLE', data)
  },
  checkPermissionCode({ state }, code) {
    return state.permissionCodes.indexOf(code) > -1
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
